<template>
  <div
    class=""
    :class="'bg-theme-' + theme"
  >
    <section
      class="px-9 md:px-12 mx-auto max-w-screen-2xl pt-32 flex flex-col pb-12"
      :class="`gsap-container-${index}`"
    >
      <p class="text-2xl md:text-4xl lg:text-5xl header">
        {{ title }}
      </p>
      <Markdown
        v-if="body"
        :md="body"
        class="max-w-2xl"
      >
        {{ body }}
      </Markdown>
    </section>
    <Vue3Marquee
      class="items-center flex"
      :duration="30"
    >
      <NuxtLink
        v-for="logo in images"
        :key="logo.alt"
        :to="logo.url"
        target="_blank"
        class="w-64 h-auto mx-32"
      >
        <NuxtPicture
          format="webp,png"
          :src="logo.src"
          :alt="logo.alt"
          :img-attrs="{ class: 'h-full w-full object-contain' }"
        />
      </NuxtLink>
    </Vue3Marquee>
  </div>
</template>

<script setup lang="ts">
import { Vue3Marquee } from 'vue3-marquee'

interface Logo extends Image {
  url: string
}
interface Props {
  title?: string
  body?: string
  uid?: string
  buttons?: Button[]
  pretitle?: string
  theme?: Theme
  index: number
  images?: Logo[]
}
const { index, theme = 'light', images = [] } = defineProps<Props>()
</script>

<style scoped>

</style>
